<template>
  <div style="width: 100%; height: 100%; overflow: hidden">
    <video ref="videoPlayer" class="video-js"/>
  </div>
</template>

<script>
import "video.js/dist/video-js.css";
import videojs from 'video.js';

export default {
  name: 'VideoPlayer',
  props: {
    onReady: {
      type: Function,
      default: () => null
    },
    onTimeUpdate: {
      type: Function,
      default: () => null
    },
    src: {
      type: String,
      default: "",
    },
    srtUrl: {
      type: String,
      default: "",
    }
  },
  watch: {
    src(nextSrc) {
      if (nextSrc) {
        this.init()
      }
    }
  },
  data() {
    return {
      player: null
    }
  },
  mounted() {

  },
  beforeDestroy() {

  },
  methods: {
    init() {
      if (this.player) {
        this.player.dispose();
      }
      this.$nextTick(() => {
        const locale = new URLSearchParams(window.location.search).get("locale");
        const options = {
          autoplay: true,
          controls: true,
          disablePictureInPicture: true,
          controlBar: {
            pictureInPictureToggle: false
          },
          sources: [
            {
              src: this.src,
              type: `video/${this.src.endsWith('webm') ? 'webm' : 'mp4'}`
            }
          ],
          ...(this.srtUrl ? {tracks: [{src: this.srtUrl, kind: 'captions', srclang: locale || "en", label: locale}]} : {})
        }
        this.player = videojs(this.$refs.videoPlayer, options, () => {
          this.onReady();
          this.player.on("timeupdate", (e) => {
            this.onTimeUpdate(this.player.currentTime(), this.player.duration())
          })
        });
      })
    }
  }
}
</script>
<style>
.video-js .vjs-control-bar {
  font-size: 125%;
}
.video-js  .vjs-texttrack-settings {
  display: none;
}
</style>
